module.exports = __webpack_public_path__ + "img/gallery12.f08e8827.png";